import { reduce } from "et3-type-guards";
import { isNumber, isString } from "lodash";

import getAuditStore from "../stores/auditor-store/audit-store";
import getTBWStore from "../stores/developer-store/tbw-store";
import { StringOrNumber } from "../Types";

export const getSelectedEventData = () => {
  const typeInput = getAuditStore().typeInputAudit.get().value;
  if (typeInput === "report") {
    const eventID = getTBWStore().TBWEventId.get();
    const eventsList = getAuditStore().adminReportEventsData.get().eventsList;
    const dataRow = eventsList.filter((values) => values.id === eventID);
    const userId: StringOrNumber = reduce(() => dataRow[0].userId, 0);
    const userUUID: string = reduce(() => dataRow[0].userUUID, "");
    const type = reduce(() => dataRow[0].type, "");
    const userIDNumber = isNumber(userId) ? userId : parseInt(userId, 10);
    const eventIDNumber = isNumber(eventID) ? eventID : parseInt(eventID, 10);
    const eventType = isString(type) ? type : "";
    return { userIDNumber, userUUID, eventIDNumber, eventType, imageID: "" };
  } else {
    const eventID = getTBWStore().TBWEventId.get();
    const eventsList = getAuditStore().adminEventsData.get().eventsList;
    const dataRow = eventsList.filter((values) => values.id === eventID);
    const userId: StringOrNumber = reduce(() => dataRow[0].userId, 0);
    const userUUID: string = reduce(() => dataRow[0].userUUID, "");
    const type = reduce(() => dataRow[0].type, "");
    const userIDNumber = isNumber(userId) ? userId : parseInt(userId, 10);
    const eventIDNumber = isNumber(eventID) ? eventID : parseInt(eventID, 10);
    const eventType = isString(type) ? type : "";

    const imageID = reduce(() => dataRow[0].imageID, "");
    return { userIDNumber, userUUID, eventIDNumber, eventType, imageID };
  }
};
